import React from 'react';
import {DashboardLayout, AuthLayout} from '@/components';
import {useSelector} from 'react-redux';
import {authStatus} from '@/services/redux/selectors';
import {Logo} from '@/components/common/logo';
import {TermsContent} from '@/components/common/TermsContent';

export const TermsScreen = () => {
  const isAuthenticated = useSelector(authStatus);
  if (isAuthenticated) {
    return (
      <DashboardLayout>
        <TermsScreenContent />
      </DashboardLayout>
    );
  }
  return (
    <AuthLayout isLayout={false}>
      <TermsScreenContent />
    </AuthLayout>
  );
};

const TermsScreenContent = () => {
  return (
    <div className="flex flex-col items-center w-full max-w-7xl mx-auto px-3 sm:px-4 -mt-10 md:-mt-12 pb-6 md:pb-8 lg:pb-16">
      {/* Terms & Conditions Card */}
      <div className="w-full bg-white rounded-2xl md:rounded-3xl shadow-2xl p-4 sm:p-6 md:p-10 lg:p-12 mb-8 md:mb-12" style={{boxShadow: '0px 10px 40px 0px rgba(0, 0, 0, 0.15)'}}>
        <TermsContent 
          titleClassName="!text-lg sm:!text-xl md:!text-2xl"
          contentClassName="!text-sm sm:!text-base md:!text-md"
        />
      </div>

      {/* Logo below content */}
      <div className="mb-6 sm:mb-8">
        <Logo imageStyle="w-[80px] sm:w-[90px] md:w-[120px]" textStyle="ml-1 text-lg sm:text-xl md:text-2xl" />
      </div>
    </div>
  );
};
